import MarketingPropertiesConfiguration from "vue/registration/subpages/marketing-properties-config.json";
const personalInfoPlaceholders = [{
	firstName: 'Arya',
	lastName: 'Stark'
}, {
	firstName: 'James',
	lastName: 'Bond'
}, {
	firstName: 'Jack',
	lastName: 'Sparrow'
}, {
	firstName: 'Mike',
	lastName: 'Wazowski'
}];

const personalizationTypes = {
	default: {
		enterEmailPage: {
			title() {
				return `Try Visor for free and start making smarter decisions.`
			},
			emailPlaceholder() {
				return 'youlookgreattoday@email.com'
			}
		},
		personalDetailsPage: {
			title() {
				return `Welcome!  Let's make your free Visor workspace`
			},
			namePlaceholder() {
				const dummyInfo = personalInfoPlaceholders[new Date().getTime() % personalInfoPlaceholders.length];
				return  {
					firstName: dummyInfo.firstName,
					lastName: dummyInfo.lastName
				}
			},
			submitButtonText() {
				return 'Continue';
			}
		},
		quickstart: {
			loadingMessage() {
				return `One sec while we get your workspace set up...`;
			}
		},
		marketingProperties: {
			title() {
				return `Help us personalize your Visor experience:`;
			},
			submitButtonText() {
				return `Create Your Free Workbook`;
			},
			configuration() {
				return MarketingPropertiesConfiguration;
			}
		},
	},
	template: {
		pm: {
			personalDetailsPage: {
				title() {
					return `Welcome!  Let's create your free project management template.`;
				},
				submitButtonText() {
					return `Get Your Free PM Template`;
				}
			},
			quickstart: {
				loadingMessage() {
					return `One second while we create your PM template...`;
				}
			},
			marketingProperties: {
				title() {
					return `Lets personalize your Visor experience`;
				},
				submitButtonText() {
					return `Create Your Free Workbook`;
				},
				configuration() {
					return MarketingPropertiesConfiguration;
				}
			},
		},
		timeline: {
			personalDetailsPage: {
				title() {
					return `Welcome!  Let's create your free timeline.`;
				},
				submitButtonText() {
					return `Get Your Free Timeline Template`;
				}
			},
			quickstart: {
				loadingMessage() {
					return `One second while we create your chore chart template...`;
				}
			},
			welcomeModal: {
				title() {
					return `Welcome to your chore chart template`;
				},
				subText() {
					return `We've pre-filled some sample chores for you.  Add your own!`;
				}
			},
			marketingProperties: {
				title() {
					return `Lets personalize your Visor experience`;
				},
				submitButtonText() {
					return `Create Your Free Workbook`;
				},
				configuration() {
					return MarketingPropertiesConfiguration;
				}
			},
		},
		okr: {
			personalDetailsPage: {
				title() {
					return `Welcome!  Let's create your free OKR template.`;
				},
				submitButtonText() {
					return `Get Your Free OKR Template`;
				}
			},
			quickstart: {
				loadingMessage() {
					return `One sec while we get your OKR template set up...`;
				}
			}
		},
		ph22: {
			enterEmailPage: {
				title() {
					return `Welcome Product Hunter! Thanks for checking us out 👍`
				},
				emailPlaceholder() {
					const allOptions = [
						'yougothunted@mail.co',
						'ultimatehunter45@email.com',
						'ihuntproducts@email.com'
					];
					return allOptions[new Date().getTime() % allOptions.length];
				}
			},
			personalDetailsPage: {
				title() {
					return `Some details before we set up your workspace. What should we call you?`
				},
			}
		},
	}
};
class PersonalizationEngine {
	constructor() {

	}
	getValue(personalizationTypeArray, valueAddress, args = []) {
		let currentNode = personalizationTypes;
		let usingDefault = !personalizationTypeArray || personalizationTypeArray[0] === 'default';

		// Get the base node to search
		for (let personalizationTypeToken of personalizationTypeArray) {
			if (currentNode[personalizationTypeToken]) {
				currentNode = currentNode[personalizationTypeToken];
			} else {
				//Ran off the edge -- not found -- go to default
				usingDefault = true;
				currentNode = personalizationTypes.default;
				break;
			}
		}
		if (!currentNode) {
			usingDefault = true;
			currentNode = personalizationTypes.default;
		}
		for (let i = 0; i < valueAddress.length; i++) {
			const addressPart = valueAddress[i];
			if (currentNode[addressPart]) {
				currentNode = currentNode[addressPart];
			} else if (!usingDefault) {
				// Restart at default object if this property doesn't exist here
				currentNode = personalizationTypes.default;
				i = -1;
				usingDefault = true;
			} else {
				// Not found in desired object or default, return null
				return null;
			}
		}
		if (currentNode) {
			if (typeof(currentNode) === 'string') {
				return currentNode;
			} else if (typeof(currentNode) === 'function') {
				return currentNode(...args);
			} else {
				assert.throwError(`Unrecognized node type in the personalization engine at [${personalizationTypeArray}]-[${valueAddress}]`);
			}
		} else {
			return null;
		}
	}
}

export default new PersonalizationEngine();